import React from 'react';
import NavBar from '../Components/NavBar';
import "./ConfirmationPage.css";

import { useNavigate } from 'react-router-dom';


import ConfettiExplosion from 'react-confetti-explosion';


const Confirmation = () => {
    const [isExploding, setIsExploding] = React.useState(true);
    const navigate = useNavigate();
    const handleConfirmation = () => {
        navigate('/confirmationpage'); // Adjust this route as needed
    };
    return (
        <>
            <NavBar />

            <div className="parent-confirmation">
                <div className="confirmation-container">
                    <div className="title-tag">
                        <h1>for shopping with Cartpool!</h1>
                        <h1>Thank you, Name</h1>
                    </div>

                    <div className="saving-info">
                        {isExploding && <ConfettiExplosion className="centered-confetti" />}
                        You just saved $15+ with Cartpool! You will receive an order confirmation email shortly to tommytrojan@usc.edu.
                    </div>
                    <div className="order-number">
                        order number: 12345
                    </div>
                    <div className="view-details">
                        <button className='button-style' onClick={handleConfirmation}>View Order Details</button>

                    </div>

                </div>
                {/* <div className="more-deets">
                    <div className="bought-details">
                        <CartProduct></CartProduct>
                        <CartProduct></CartProduct>
                        <CartProduct></CartProduct>
                    </div>
                    <div className="more-details">
                        <div className="order-details">
                            <div className="estimated-arrival">
                                Estimated Arrival: X
                            </div>
                            <OrderDetails></OrderDetails>
                        </div>
                        <div className="pickup-container">
                            <div class="pickup-loc">
                                Pickup Location:
                            </div>
                            <div class="row-confirmation">
                                <div class="location">
                                    USC Village
                                </div>
                                <div class="switch-loc">
                                    Switch
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </>
    );
};

export default Confirmation;
